module.exports = __webpack_public_path__ + "static/media/cert_104-tc.7745ca57.jpg";